import React from "react";
import StarIcon from "@mui/icons-material/Star";

const Index = () => {
  return (
    <div className="bg-white py-4 flex items-center justify-center shadow-lg">
      <a
        href="https://www.bbb.org/us/tx/san-antonio/profile/debt-relief-education/debt-redemption-inc-dba-affordable-debt-consolidation-0825-90006140/#sealclick"
        className="me-4"
        target="_blank"
        rel="noreferrer"
      >
        <img
          src="https://seal-austin.bbb.org/seals/blue-seal-250-52-bbb-90006140.png"
          className="w-full max-h-16"
          style={{
            border: "0",
          }}
          alt="Debt Redemption Inc DBA Affordable Debt Consolidation BBB Business Review"
        />
      </a>
      <p className="text-md font-normal hidden sm:block">Our customers say</p>
      <p className="text-lg font-semibold mx-3 hidden sm:block">Excellent</p>
      <div className="flex items-center me-3">
        {[1, 2, 3, 4, 5].map((index) => (
          <div className="p-1 bg-green-800 me-1 flex" key={index}>
            <StarIcon className="text-white text-sm" />
          </div>
        ))}
      </div>
      <p className="hidden md:block font-bold text-xs lg:text-lg">
        A+ BBB Rating with Zero Complaints
      </p>
    </div>
  );
};

export default Index;
